/* ÉnTervező Főoldal POC — interakciók (körhinták, menük, scroll-reveal) */
(function () {
  "use strict";

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  /* ---------- Fejléc: desktop dropdownok ---------- */
  function initDropdowns() {
    var dropdowns = Array.prototype.slice.call(document.querySelectorAll("[data-dropdown]"));
    dropdowns.forEach(function (dd) {
      var toggle = dd.querySelector("[data-dropdown-toggle]");
      var menu = dd.querySelector("[data-dropdown-menu]");
      var caret = dd.querySelector("[data-caret]");
      if (!toggle || !menu) return;
      toggle.addEventListener("click", function (e) {
        e.stopPropagation();
        var isOpen = !menu.classList.contains("hidden");
        // csukjuk a többit
        dropdowns.forEach(function (o) {
          var m = o.querySelector("[data-dropdown-menu]");
          var c = o.querySelector("[data-caret]");
          if (m) m.classList.add("hidden");
          if (c) c.classList.remove("rotate-180");
        });
        if (!isOpen) {
          menu.classList.remove("hidden");
          if (caret) caret.classList.add("rotate-180");
        }
      });
    });
    document.addEventListener("click", function () {
      dropdowns.forEach(function (o) {
        var m = o.querySelector("[data-dropdown-menu]");
        var c = o.querySelector("[data-caret]");
        if (m) m.classList.add("hidden");
        if (c) c.classList.remove("rotate-180");
      });
    });
  }

  /* ---------- Fejléc: mobil menü ---------- */
  function initMobileMenu() {
    var toggle = document.querySelector("[data-mobile-toggle]");
    var menu = document.querySelector("[data-mobile-menu]");
    if (!toggle || !menu) return;
    var openIcon = toggle.querySelector("[data-menu-open]");
    var closeIcon = toggle.querySelector("[data-menu-close]");
    toggle.addEventListener("click", function () {
      var isHidden = menu.classList.toggle("hidden");
      if (openIcon) openIcon.classList.toggle("hidden", !isHidden);
      if (closeIcon) closeIcon.classList.toggle("hidden", isHidden);
    });

    // mobil accordionok
    var accToggles = menu.querySelectorAll("[data-acc-toggle]");
    Array.prototype.forEach.call(accToggles, function (t) {
      t.addEventListener("click", function () {
        var panel = t.nextElementSibling;
        var caret = t.querySelector("[data-caret]");
        if (panel && panel.hasAttribute("data-acc-panel")) {
          panel.classList.toggle("hidden");
          if (caret) caret.classList.toggle("rotate-180");
        }
      });
    });
  }

  /* ---------- Hero körhinta ---------- */
  function initHero() {
    var root = document.querySelector("[data-hero]");
    if (!root) return;
    var track = root.querySelector("[data-hero-track]");
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    var dotsWrap = root.querySelector("[data-hero-dots]");
    if (!track || slides.length === 0) return;

    var index = 0;
    var count = slides.length;

    // pontok
    var dots = [];
    if (dotsWrap) {
      for (var i = 0; i < count; i++) {
        (function (i) {
          var b = document.createElement("button");
          b.type = "button";
          b.setAttribute("aria-label", i + 1 + ". dia");
          b.className = "h-1.5 rounded-full transition-all " + (i === 0 ? "w-8 bg-white" : "w-4 bg-white/50");
          b.addEventListener("click", function () { go(i); });
          dotsWrap.appendChild(b);
          dots.push(b);
        })(i);
      }
    }

    function render() {
      track.style.transform = "translateX(" + (-index * 100) + "%)";
      track.style.transition = "transform 0.6s ease";
      dots.forEach(function (d, i) {
        d.className = "h-1.5 rounded-full transition-all " + (i === index ? "w-8 bg-white" : "w-4 bg-white/50");
      });
    }
    function go(i) { index = (i + count) % count; render(); }
    function next() { go(index + 1); }
    function prev() { go(index - 1); }

    var prevBtn = root.querySelector("[data-hero-prev]");
    var nextBtn = root.querySelector("[data-hero-next]");
    if (prevBtn) prevBtn.addEventListener("click", prev);
    if (nextBtn) nextBtn.addEventListener("click", next);

    render();
    var timer = setInterval(next, 20000);
    root.addEventListener("mouseenter", function () { clearInterval(timer); });
    root.addEventListener("mouseleave", function () { timer = setInterval(next, 20000); });
  }

  /* ---------- Scroll-alapú körhinta (webshop + videók) ---------- */
  function initScrollCarousel(rootSel, viewportSel, prevSel, nextSel, autoplayMs) {
    var root = document.querySelector(rootSel);
    if (!root) return;
    var viewport = root.querySelector(viewportSel);
    if (!viewport) return;
    var prevBtn = root.querySelector(prevSel);
    var nextBtn = root.querySelector(nextSel);

    function step() {
      var firstItem = viewport.querySelector(":scope > div > *") || viewport.querySelector(":scope > *");
      return firstItem ? firstItem.getBoundingClientRect().width + 16 : viewport.clientWidth * 0.5;
    }
    function atEnd() {
      return viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 4;
    }
    if (nextBtn) nextBtn.addEventListener("click", function () {
      viewport.scrollBy({ left: step(), behavior: "smooth" });
    });
    if (prevBtn) prevBtn.addEventListener("click", function () {
      viewport.scrollBy({ left: -step(), behavior: "smooth" });
    });

    if (autoplayMs) {
      var timer = setInterval(function () {
        if (atEnd()) viewport.scrollTo({ left: 0, behavior: "smooth" });
        else viewport.scrollBy({ left: step(), behavior: "smooth" });
      }, autoplayMs);
      root.addEventListener("mouseenter", function () { clearInterval(timer); });
      root.addEventListener("mouseleave", function () { timer = setInterval(function () {
        if (atEnd()) viewport.scrollTo({ left: 0, behavior: "smooth" });
        else viewport.scrollBy({ left: step(), behavior: "smooth" });
      }, autoplayMs); });
    }
  }

  /* ---------- Scroll-reveal (framer-motion helyett) ---------- */
  function initReveal() {
    var els = Array.prototype.slice.call(document.querySelectorAll(".reveal"));
    if (els.length === 0) return;
    if (!("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("reveal-in"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("reveal-in");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  ready(function () {
    initDropdowns();
    initMobileMenu();
    initHero();
    initScrollCarousel("[data-prod]", "[data-prod-viewport]", "[data-prod-prev]", "[data-prod-next]", 5000);
    initScrollCarousel("[data-vid]", "[data-vid-viewport]", "[data-vid-prev]", "[data-vid-next]", 0);
    initReveal();
  });
})();
